import ApiService from './ApiService'

// ---------------------------------------------------------------------------
// Ticket-scoped actions (TSTicketActions)
// ---------------------------------------------------------------------------

export async function apiListTicketActions(data) {
    return ApiService.fetchData({
        url: '/ticket/actions/list',
        method: 'post',
        data,
    })
}

export async function apiUpsertTicketAction(data) {
    return ApiService.fetchData({
        url: '/ticket/actions/upsert',
        method: 'post',
        data,
    })
}

export async function apiResolveTicketAction(data) {
    return ApiService.fetchData({
        url: '/ticket/actions/resolve',
        method: 'post',
        data,
    })
}

export async function apiGetActionKBMockup(data) {
    return ApiService.fetchData({
        url: '/ticket/actions/kb-mockups/get',
        method: 'post',
        data,
    })
}

export async function apiCopyActionKBMockupToUser(data) {
    return ApiService.fetchData({
        url: '/ticket/actions/kb-mockups/copy-to-user',
        method: 'post',
        data,
    })
}

export async function apiRegenerateActionKBMockup(data) {
    return ApiService.fetchData({
        url: '/ticket/actions/kb-mockups/regenerate',
        method: 'post',
        data,
    })
}

// ---------------------------------------------------------------------------
// Pooled user actions (TSUserActions)
// ---------------------------------------------------------------------------

export async function apiListPooledActions(data) {
    return ApiService.fetchData({
        url: '/user/actions/list',
        method: 'post',
        data,
    })
}

export async function apiUpsertPooledAction(data) {
    return ApiService.fetchData({
        url: '/user/actions/upsert',
        method: 'post',
        data,
    })
}

export async function apiApplyPooledAction(data) {
    return ApiService.fetchData({
        url: '/user/actions/apply',
        method: 'post',
        data,
    })
}

export async function apiDismissPooledAction(data) {
    return ApiService.fetchData({
        url: '/user/actions/dismiss',
        method: 'post',
        data,
    })
}

export async function apiDeletePooledAction(data) {
    return ApiService.fetchData({
        url: '/user/actions/delete',
        method: 'post',
        data,
    })
}
